import { Box, CssBaseline, GlobalStyles, ThemeProvider, createTheme } from "@mui/material";
import SoupKitchenRoundedIcon from "@mui/icons-material/SoupKitchenRounded";
import BakeryDiningRoundedIcon from "@mui/icons-material/BakeryDiningRounded";
import RamenDiningRoundedIcon from "@mui/icons-material/RamenDiningRounded";
import SetMealRoundedIcon from "@mui/icons-material/SetMealRounded";
import IcecreamRoundedIcon from "@mui/icons-material/IcecreamRounded";
import LocalCafeRoundedIcon from "@mui/icons-material/LocalCafeRounded";
import SearchForm from "./features/SearchForm";
import RecipeResults from "./features/searchResults/components/RecipeResults";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f97316",
      light: "#fdba74",
      dark: "#c2410c",
    },
    secondary: {
      main: "#0ea5e9",
      light: "#7dd3fc",
      dark: "#0369a1",
    },
    background: {
      default: "#fff8e6",
      paper: "#fffdf7",
    },
    text: {
      primary: "#5b3417",
      secondary: "#7c5a3a",
    },
  },
  typography: {
    fontFamily: '"Trebuchet MS", "Segoe UI", sans-serif',
    h1: {
      fontWeight: 900,
      letterSpacing: "-0.04em",
    },
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.03em",
    },
    h4: {
      fontWeight: 800,
    },
    button: {
      fontWeight: 800,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 10,
  },
});

const floatingIcons = [
  { Icon: SoupKitchenRoundedIcon, top: "8%", left: "6%", color: "#f97316", delay: "0s", size: 42 },
  { Icon: BakeryDiningRoundedIcon, top: "18%", right: "8%", color: "#0ea5e9", delay: "1s", size: 40 },
  { Icon: RamenDiningRoundedIcon, top: "62%", left: "4%", color: "#facc15", delay: "2s", size: 46 },
  { Icon: SetMealRoundedIcon, top: "72%", right: "7%", color: "#fb923c", delay: "0.5s", size: 40 },
  { Icon: IcecreamRoundedIcon, top: "38%", right: "3%", color: "#38bdf8", delay: "1.8s", size: 36 },
  { Icon: LocalCafeRoundedIcon, top: "48%", left: "8%", color: "#f59e0b", delay: "1.2s", size: 38 },
];

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            background:
              "radial-gradient(circle at top left, rgba(125, 211, 252, 0.45), transparent 25%), radial-gradient(circle at top right, rgba(250, 204, 21, 0.35), transparent 22%), linear-gradient(180deg, #fff6db 0%, #fff7ed 45%, #fef3c7 100%)",
          },
          "@keyframes floaty": {
            "0%, 100%": { transform: "translateY(0px)" },
            "50%": { transform: "translateY(-14px)" },
          },
          "@keyframes steamDrift": {
            "0%": { transform: "translateY(14px) scale(0.9)", opacity: 0 },
            "25%": { opacity: 0.45 },
            "100%": { transform: "translateY(-22px) scale(1.08)", opacity: 0 },
          },
        }}
      />
      <Box
        className="App"
        sx={{
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
          px: { xs: 2, md: 4 },
          py: { xs: 3, md: 5 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
          }}
        >
          {floatingIcons.map(({ Icon, delay, size, ...position }, index) => (
            <Box
              key={index}
              sx={{
                position: "absolute",
                animation: "floaty 6s ease-in-out infinite",
                animationDelay: delay,
                opacity: 0.9,
                ...position,
              }}
            >
              <Icon sx={{ fontSize: size, color: position.color }} />
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            maxWidth: 1200,
            mx: "auto",
          }}
        >
          <SearchForm />
          <RecipeResults />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
